import { Quote } from '../quotation';
import { useQueryClient } from 'react-query';
import { useCallback, useMemo } from 'react';
import { Session } from '../session';
import { StandardPaymentParams } from '@app/analytics';
import { useSession } from '..';

export const getAnalyticsStdParamsFromQuote = (quote: Quote) => {
  return {
    checkout_id: quote.ref,
    order_id: quote.id,
    currency: 'EUR',
    organizationId: quote.organizationId,
  };
};

const buildSessionAnalyticsParams = (session?: Session) => {
  if (!session) {
    return {};
  }
  const sessionOnlyParams = {
    id: session.id,
    sessionId: session.id,

    organizationId: session.organizationId,

    recruitmentId: session.recruitmentId,
    planId: session.planId,
    quoteId: session.quoteId,

    status: session.status,
    format: session.format,
    studyType: session.studyType,
    studySubject: session.studySubject,
    internalName: session.internalName,
    duration: session.duration,
    durationDisplayed: session.durationDisplayed,
    incentiveText: session.incentiveText,
    locale: session.locale,
    startDate: session.startDate,
    endDate: session.endDate,

    numberOfBooked: session.numberOfBooked,
    numberOfParticipantRequired: session.numberOfParticipantRequired,

    validFormSteps: session.validFormSteps,
    archivedAt: session.archivedAt,
    createdAt: session.createdAt,
    updatedAt: session.updatedAt,
    deletedAt: session.deletedAt,
    publishedAt: session.publishedAt,
    cancelledAt: session.cancelledAt,
    ownerId: session.ownerId,
    taskSettingId: session.taskSettingId,

    checkout_id: session.id,
    order_id: session.quoteId,
  };
  return sessionOnlyParams;
};

export const useGetSessionAnalyticsParams = () => {
  return useCallback(async (session?: Session) => {
    if (!session) {
      return;
    }
    return buildSessionAnalyticsParams(session);
  }, []);
};

export const useSessionAnalyticsParams = (sessionId?: string) => {
  const { data: session } = useSession(sessionId);

  return useMemo(() => {
    return buildSessionAnalyticsParams(session);
  }, [session]);
};
